export default __webpack_public_path__ + "static/media/copyright.797d09c9.svg";